﻿import { defineStore } from 'pinia'
import type { Ref } from 'vue'
import { ref } from 'vue'

export interface UseLoadingStore {
    loading: Ref<boolean>
    startLoading: () => void
    stopLoading: () => void
}
export const useLoadingStore = defineStore(
    'loadingStore',
    function (): UseLoadingStore {
        const loading = ref(false)
        function setLoading(value: boolean) {
            loading.value = value
        }
        function startLoading() {
            setLoading(true)
        }
        function stopLoading() {
            setLoading(false)
        }
        return { loading, startLoading, stopLoading }
    }
)
